import { render, staticRenderFns } from "./custom-form-factory.vue?vue&type=template&id=5f37c026&scoped=true&"
import script from "./custom-form-factory.vue?vue&type=script&lang=js&"
export * from "./custom-form-factory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37c026",
  null
  
)

export default component.exports